<template>
  <div>
    <p>This permit relates to entry into any enclosed space and should be completed by the master or responsible person</p>

    <!--    기본정보-->
    <field-select-module
      class="mt-28px"
      title="Basic Information"
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      field-name="Company"
      :typeslabel="fieldTypesLabel"
    />

    <!-- GENERAL -->
    <div>
      <h5 class="my-4"><i class="dot"></i> GENERAL</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div class="container-title">Location / Enclosed Space</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div class="writeGridLineItem">
          <div class="container-title">Reason of Entry</div>
          <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputA_2 }}</p>
          <ml-textarea v-else :readonly="board.readonly" v-model="form.inputA_2" rows="5" />
        </div>
      </div>
      <p style="font-weight: 500;">The Responsible Officer (C/O and 1/E) shall complete this permit & <span style="color: red;">risk assessment work sheet</span> and provide it to the Master for approval and validation. Permit not valid until signed by Master.</p>
      <p class="my-4" style="color: red; font-weight: 700;">* Duration not to exceed 8 hours for any one permit in a day.</p>
    </div>

    <!-- pre 1 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 1. Pre-entry Preparation
        <span class="mx-1 container-subtitle">(To be checked by master or responsible officer)</span>
      </h5>
      <table>
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
        </colgroup>
        <thead>
        <tr>
          <th>Safety Measures Requirements</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.pre1">
          <template v-if="item.isCustom">
            <td v-if="item.type === 1" class="content">
              <div class="content-title" v-html="item.text" />
              <div class="py-2 px-8 block">

                <div class="flex items-center py-1">
                  <span style="width: 120px;">Time</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.time }}</p>
                  <time-selector v-else="isPrint" v-model="item.time" style="width: 200px;" />

                  <span class="ml-8 mr-4">Checked by</span>
                  <p v-if="isPrint" class="print-input flex-1">{{ item.by }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.by" />
                  <span class="mx-2">(Rank)</span>
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">O2</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.o2 }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.o2" style="width: 200px;"/>
                  <span class="mx-2">%vol (19%~23.5%)</span>
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">CH4</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.ch4_1 }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.ch4_1" style="width: 200px;"/>
                  <span class="mx-2">%LEL (<20%)</span>

                  <span class="ml-2 mr-4">or</span>
                  <p v-if="isPrint" class="print-input flex-1">{{ item.ch4_2 }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.ch4_2" />
                  <span class="mx-2">%LEL (<20%)</span>
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">CO</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.co }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.co" style="width: 200px;"/>
                  <span class="mx-2">ppm (<30ppm)</span>
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">H2S</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.h2s }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.h2s" style="width: 200px;"/>
                  <span class="mx-2">ppm(<5 ppm)</span>
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">H2</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.h2 }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.h2" style="width: 200px;"/>
                  <span class="mx-2">ppm (<0.01% or 100 PPM (1차 설정 알람 1st Stage Setup Alarm))</span>
                </div>

                <p class="mt-2">(단, H2는 전기분해방식 BWTS가 설치된 선박에서만 측정)</p>
                <p>(Note: H2 measurements are only applicable on ships equipped with the electrolytic BWTS)</p>

              </div>
            </td>
            <td v-else class="content">
              <div class="content-title" v-html="item.text" />
              <div class="py-2 px-8 block">
                <div class="flex items-center py-1">
                  <span class="mr-2">Rank / Name of watchman</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.watchMan }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.watchMan" style="width: 200px;"/>
                </div>
              </div>
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'Yes'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'Yes'"
                           @change="item.isChecked === 'Yes' ? item.isChecked = '' : item.isChecked = 'Yes'" class="i-check justify-center" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'No'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'No'"
                           @change="item.isChecked === 'No' ? item.isChecked = '' : item.isChecked = 'No'" class="i-check justify-center" />
            </td>
          </template>
          <template v-else>
            <td class="content">
              <div class="content-title" v-html="item.text" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'Yes'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'Yes'"
                           @change="item.isChecked === 'Yes' ? item.isChecked = '' : item.isChecked = 'Yes'" class="i-check justify-center" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'No'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'No'"
                           @change="item.isChecked === 'No' ? item.isChecked = '' : item.isChecked = 'No'" class="i-check justify-center" />
            </td>
          </template>
        </tr>
        </tbody>
      </table>
      <p class="mt-3">* It should be noted that this is a generic entry permit that may be used for all enclosed spaces on board all ships.</p>
      <p>** Note that National requirements may determine the safe atmosphere range.</p>
    </div>

    <!-- pre 2 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 2. Pre-entry Checks
        <span class="mx-1 container-subtitle">(To be checked by each personnel entry)</span>
      </h5>
      <table>
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
        </colgroup>
        <thead>
        <tr>
          <th>Safety Measures Requirements</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.pre2">
          <template v-if="item.isCustom">
            <td class="content">
              <div>
                <span>·</span>I have agreed upon a reporting interval of
                <p v-if="isPrint" class="print-input flex-1" style="width: 80px;">{{ item.text }}</p>
                <ml-input v-else :readonly="board.readonly" v-model="item.text" style="width: 80px;"/>
                minutes
              </div>
              <div class="mt-2">
                <span>·</span>본인은
                <p v-if="isPrint" class="print-input flex-1" style="width: 80px;">{{ item.text }}</p>
                <ml-input v-else :readonly="board.readonly" v-model="item.text" style="width: 80px;"/>
                분 간격으로 보고하기로 동의하였습니다.
              </div>
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'Yes'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'Yes'"
                           @change="item.isChecked === 'Yes' ? item.isChecked = '' : item.isChecked = 'Yes'" class="i-check justify-center" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'No'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'No'"
                           @change="item.isChecked === 'No' ? item.isChecked = '' : item.isChecked = 'No'" class="i-check justify-center" />
            </td>
          </template>
          <template v-else>
            <td class="content">
              <div class="content-title" v-html="item.text" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'Yes'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'Yes'"
                           @change="item.isChecked === 'Yes' ? item.isChecked = '' : item.isChecked = 'Yes'" class="i-check justify-center" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'No'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'No'"
                           @change="item.isChecked === 'No' ? item.isChecked = '' : item.isChecked = 'No'" class="i-check justify-center" />
            </td>
          </template>
        </tr>
        <tr>
          <td class="content" colspan="3">
            <div class="content-title">Personnel entry (Rank / Name / Signature</div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- 서명1 -->
    <div class="mt-28px">
      <h5 class="mb-4">Personnel entry (Rank / Name / Signature)</h5>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Rank</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.rank" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.rank }}</span>
        </div>
        <div>
          <div>Name</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Rank</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.rank" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.rank }}</span>
        </div>
        <div>
          <div>Name</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Rank</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.rank" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.rank }}</span>
        </div>
        <div>
          <div>Name</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign3.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- pre 3 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 3. Breathing Apparatus and Other Equipment
        <span class="mx-1 container-subtitle">(To be checked by master of responsible officer and the personnel entry)</span>
      </h5>
      <table>
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
        </colgroup>
        <thead>
        <tr>
          <th>Safety Measures Requirements</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.pre3">
          <template>
            <td class="content">
              <div class="content-title" v-html="item.text" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'Yes'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'Yes'"
                           @change="item.isChecked === 'Yes' ? item.isChecked = '' : item.isChecked = 'Yes'" class="i-check justify-center" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'No'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'No'"
                           @change="item.isChecked === 'No' ? item.isChecked = '' : item.isChecked = 'No'" class="i-check justify-center" />
            </td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- 서명 2 -->
    <div class="mt-28px">
      <h5 class="mb-4">SIGNED UPON COMPLETION OF SECTION 1, 2 AND 3 BY:</h5>
      <p>THT UNDERSIGNED CONFIRM THAT ALL PREVENTIVE MEASURES HAVE BEEN TAKEN AND THE SAFETY MEASURES WILL BE MAINTAINED DURING THE OCCUPANCY IN THE SPACE.</p>
      <p>본인은 모든 예방조치가 취해졌으며, 작업기간에도안전조치가 유지될 것임을 확인하였습니다.</p>

      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Responsible Officer</div>
          <ml-input v-if="!isPrint" v-model="form.sign4.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign4.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign4.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign4.sign" :src="form.sign4.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div>
          <div>Date/Time</div>
          <div>
            <ml-input v-if="!isPrint" class="w-full" v-model="form.sign4.date" :readonly="true" />
            <span v-else class="print-input w-full">{{ form.sign4.date }}</span>
          </div>
        </div>
      </div>

      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Personnel entry</div>
          <ml-input v-if="!isPrint" v-model="form.sign5.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign5.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign5.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign5.sign" :src="form.sign5.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div>
          <div>Date/Time</div>
          <div>
            <ml-input v-if="!isPrint" class="w-full" v-model="form.sign5.date" :readonly="true" />
            <span v-else class="print-input w-full">{{ form.sign5.date }}</span>
          </div>
        </div>
      </div>

      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Safety Officer (C/E)</div>
          <ml-input v-if="!isPrint" v-model="form.sign6.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign6.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign6.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign6.sign" :src="form.sign6.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div>
          <div>Date/Time</div>
          <div>
            <ml-input v-if="!isPrint" class="w-full" v-model="form.sign6.date" :readonly="true" />
            <span v-else class="print-input w-full">{{ form.sign6.date }}</span>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>APPROVED BY MASTER</div>
          <ml-input v-if="!isPrint" v-model="form.sign7.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign7.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign7.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign7.sign" :src="form.sign7.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div>
          <div>Date/Time</div>
          <div>
            <ml-input v-if="!isPrint" class="w-full" v-model="form.sign7.date" :readonly="true" />
            <span v-else class="print-input w-full">{{ form.sign7.date }}</span>
          </div>
        </div>
      </div>

      <div>
        <div class="flex" style="align-items: center;">
          <div style="width: 130px; font-weight: 500; font-size: 14px;">Permit Validity</div>
          <span v-if="isPrint" class="print-input flex-1" style="width: 230px;">{{ form.inputB_1 }}</span>
          <time-selector v-else :readonly="board.readonly" v-model="form.inputB_1" style="width: 230px;"/>
          <span class="mx-4">~</span>
          <span v-if="isPrint" class="print-input flex-1" style="width: 230px;">{{ form.inputB_2 }}</span>
          <time-selector v-else :readonly="board.readonly" v-model="form.inputB_2" style="width: 230px;"/>
          <span class="mx-4">(maximum 8 hours)</span>
        </div>
      </div>
    </div>

    <!-- 4.  -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 4. Personnel Entry
        <span class="mx-1 container-subtitle">(To be completed by the responsible officer)</span>
      </h5>
      <div class="writeGridContainer">
        <div>
          <div>Time in</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_2 }}</p>
          <time-selector v-else :readonly="board.readonly" v-model="form.inputC_2" />
        </div>
        <div>
          <div>Time out</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_3 }}</p>
          <time-selector v-else :readonly="board.readonly" v-model="form.inputC_3" />
        </div>
      </div>
    </div>

    <!-- 서명 3 -->
    <div class="mt-4">
      <div class="mb-4">Personnel entry (Rank / Name / Signature)</div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Rank</div>
          <ml-input v-if="!isPrint" v-model="form.sign8.rank" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign8.rank }}</span>
        </div>
        <div>
          <div>Name</div>
          <ml-input v-if="!isPrint" v-model="form.sign8.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign8.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign8.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign8.sign" :src="form.sign8.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Rank</div>
          <ml-input v-if="!isPrint" v-model="form.sign9.rank" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign9.rank }}</span>
        </div>
        <div>
          <div>Name</div>
          <ml-input v-if="!isPrint" v-model="form.sign9.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign9.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign9.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign9.sign" :src="form.sign9.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Rank</div>
          <ml-input v-if="!isPrint" v-model="form.sign10.rank" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign10.rank }}</span>
        </div>
        <div>
          <div>Name</div>
          <ml-input v-if="!isPrint" v-model="form.sign10.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign10.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign10.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign10.sign" :src="form.sign10.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 5. -->
    <div class="mt-28px">
      <div class="flex justify-between" style="align-items: center;">
        <h5 class="my-4"><i class="dot"></i> 5. Atmosphere Testing Log while the Space Is Occupied
          <span class="mx-1 container-subtitle" style="color: #ea5455;">(Interval should not exceed 30 minutes.)</span>
        </h5>
        <div>
          <vs-button class="mr-4" color="secondary" @click="handleAddRow1">Add item</vs-button>
          <vs-button color="secondary" type="border" @click="handleRemoveRow1">Delete item</vs-button>
        </div>
      </div>
      <table>
        <thead>
        <tr>
          <th>Time</th>
          <th>O2</th>
          <th>H2S</th>
          <th>CH4</th>
          <th>CO</th>
          <th>H4</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.pre5">
          <td class="p-1">
            <p v-if="isPrint" class="print-input flex-1">{{ item.time }}</p>
            <time-selector v-else :readonly="board.readonly" v-model="item.time" />
          </td>
          <td class="px-1">
            <p v-if="isPrint" class="print-input flex-1">{{ item.o2 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item.o2" class="w-full" />
          </td>
          <td class="px-1">
            <p v-if="isPrint" class="print-input flex-1">{{ item.h2s }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item.h2s" class="w-full" />
          </td>
          <td class="px-1">
            <p v-if="isPrint" class="print-input flex-1">{{ item.ch4 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item.ch4" class="w-full" />
          </td>
          <td class="px-1">
            <p v-if="isPrint" class="print-input flex-1">{{ item.co }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item.co" class="w-full" />
          </td>
          <td class="px-1">
            <p v-if="isPrint" class="print-input flex-1">{{ item.h4 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item.h4" class="w-full" />
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- 6. -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 6.		Communication Log during the Entry
        <span class="mx-1 container-subtitle" style="color: #ea5455;">(Interval should not exceed 30 minutes.)</span>
      </h5>
      <div class="flex justify-between" style="align-items: center;">
        <div class="flex" style="align-items: center;">
          Reporting interval  :
          <ml-input v-if="isPrint" class="print-input flex-1 mx-4" style="width: 100px;">{{ form.inputD_1 }}</ml-input>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_1" style="width: 100px;" class="mx-4"/>
          minutes
        </div>
        <div>
          <vs-button class="mr-4" color="secondary" @click="handleAddRow2">Add item</vs-button>
          <vs-button color="secondary" type="border" @click="handleRemoveRow2">Delete item</vs-button>
        </div>
      </div>
      <table class="mt-4">
        <thead>
        <tr>
          <th>Time</th>
          <th>O2</th>
          <th>H2S</th>
          <th>CH4</th>
          <th>CO</th>
          <th>H4</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.pre6">
          <td class="p-1">
            <p v-if="isPrint" class="print-input flex-1">{{ item.time }}</p>
            <time-selector v-else :readonly="board.readonly" v-model="item.time" />
          </td>
          <td v-for="n in 5" :key="n" class="p-1">
            <p v-if="isPrint" class="print-input flex-1">{{ item['input' + n] }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item['input' + n]" class="w-full" />
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- pre 7 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 7. Completion of Job
        <span class="mx-1 container-subtitle">(To be completed by the responsible office)</span>
      </h5>
      <table>
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
        </colgroup>
        <thead>
        <tr>
          <th>Safety Measures Requirements</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.pre7">
          <template>
            <td class="content">
              <div class="content-title">{{ item.text }}</div>
            </td>
            <td class="px-1">
              <p v-if="isPrint" class="print-input flex-1">{{ item.date }}</p>
              <date-selector v-else :readonly="board.readonly" v-model="item.date" />
            </td>
            <td class="px-1">
              <p v-if="isPrint" class="print-input flex-1">{{ item.time }}</p>
              <time-selector v-else :readonly="board.readonly" v-model="item.time" />
            </td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- 서명 4 -->
    <div class="mt-28px">
      <p style="font-weight: 500;">THE UNDERSIGNED CONFIRM THAT THE JOB HAS BEEN COMPLETED AND ALL PERSONNEL AND EQUIPMENT HAVE BEEN WITHDRAWN UNDER CONTROL OF THE UNDERSIGNED.</p>
      <p style="font-weight: 500;">작업이 완료되었고 본인의 감독하에 모든 인원과 장비가 철수되었음을 확인합니다.</p>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Responsible Officer</div>
          <ml-input v-if="!isPrint" v-model="form.sign11.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign11.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign11.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign11.sign" :src="form.sign11.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div>
          <div>Date/Time</div>
          <div>
            <ml-input v-if="!isPrint" class="w-full" v-model="form.sign11.date" :readonly="true" />
            <span v-else class="print-input w-full">{{ form.sign11.date }}</span>
          </div>
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" title="Attachments" lang="en" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import SignField from "@/components/SignField.vue";
import Pagination from "@/components/Pagination.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {
    PrintCheckbox,
    TimeSelector,
    Pagination,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputB_1: "",
        inputB_2: "",
        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputD_1: "",


        pre1: [
          { isCustom: false, text: "Has the risk assessment has been carried out?<br/>위험성평가는 이행되었는가?", isChecked: "" },
          { isCustom: false, text: "Has the space been thoroughly ventilated by mechanical means? <br/>작업구역은 완전히 환기되었는가?", isChecked: "" },
          { isCustom: false, text: "Has the space been segregated by blanking off or isolating all connecting pipelines or valves and electrical power/equipment? <br/>작업구역의 모든 pipeline, 밸브 및 전력/전기장치는 차단되었는가?", isChecked: "" },
          { isCustom: false, text: "Has the space been cleaned where necessary? <br/>작업에 필요한 구역이 청결한가?", isChecked: "" },
          { isCustom: false, text: "Has the space been tested and found safe for entry? <br/>작업구역은 점검되었고 안전이 확인되었는가?", isChecked: "" },
          {
            isCustom: true,
            type: 1,
            text: "Has atmosphere testing performed at several locations and levels?<br/>공기측정은 여러 위치와 여러 깊이에서 수행되었는가?",
            time: "",
            by: "",
            o2: "",
            ch4_1: "",
            ch4_2: "",
            co: "",
            h2s: "",
            h2: "",
            isChecked: ""
          },
          { isCustom: false, text: "Have arrangements been made for frequent atmosphere checks to be made while the space is occupied and after work breaks? <br/>작업 중 주기적인 공기측정과 휴식 후 공기측정 할 수 있는 준비가 완료되었는가?\n", isChecked: "" },
          { isCustom: false, text: "Have arrangements been made for the space to be continuously ventilated throughout the period of occupation and during work breaks? <br/>작업 중 및 휴식시간에 환기가 계속되도록 조치하였는가?", isChecked: "" },
          { isCustom: false, text: "Are access and illumination adequate? <br/>내부의 조명은 적절한가?", isChecked: "" },
          { isCustom: false, text: "Is rescue and resuscitation equipment available for immediate use by the entrance to the space?<br/>밀폐구역 입구에 구조장비 및 응급처리기구를 즉시 사용할 수 있도록 준비하였는가?\n", isChecked: "" },
          {
            isCustom: true,
            type: 2,
            text: "Has an attendance been designated to be in constant attendance at the entrance to the space?<br/>밀폐구역 입구에는 감시자가 항상 대기하도록 배치하였는가?",
            watchMan: "",
            isChecked: ""
          },
          { isCustom: false, text: "Has the office of the watch (bridge, engine room, cargo control room) been advised of planned entry?<br/>당직사관에게 밀폐구역 진입계획을 알렸는가?\n", isChecked: "" },
          { isCustom: false, text: "Has the system of communication between all parties been tested and emergency signal agreed? <br/>밀폐구역 내 작업자와 감시자는 통신수단을 갖추고 시험하였으며 비상신호를 상호확인 하였는가?", isChecked: "" },
          { isCustom: false, text: "Are emergency and evacuation procedures established and understood by all personnel involved with the enclosed space entry? <br/>비상탈출절차가 준비되었고 작업자는 이해하였는가?", isChecked: "" },
          { isCustom: false, text: "Is all equipment used in good working condition and inspected prior to entry?<br/>사용되는 모든 장비는 정상상태이고 진입 전에 확인되었는가?", isChecked: "" },
          { isCustom: false, text: "Are personnel properly clothed and equipped?<br/>작업자의 복장과 장비는 적절한가?", isChecked: "" },
        ],
        pre2: [
          { isCustom: false, text: "I have received instructions or permission from master or responsible officer to enter the enclosed space. <br/>본인은 책임사관(선장)으로부터 밀폐구역 진입에 대한 지시사항 및 허가를 받았습니다.", isChecked: "" },
          { isCustom: false, text: "I have confirmed above mentioned item has been satisfactorily completed by the master or responsible officer. <br/>본인은 상기 책임사관(선장)이 점검한 항목에 대해 만족합니다.", isChecked: "" },
          { isCustom: false, text: "I have agreed and understood the communication procedures.<br/>본인은 통신절차에 동의하였고 이해하였습니다.", isChecked: "" },
          { isCustom: true, text: "", isChecked: "" },
          { isCustom: false, text: "Emergency and evacuation procedure have been agreed and are understood.<br/>비상탈출절차에 동의하였고 숙지하였습니다.", isChecked: "" },
          { isCustom: false, text: "I am aware that the space must be vacated immediately in the event of ventilation failure or if atmosphere tests show a change from agreed safe criteria. <br/>본인은 통풍문제 또는 공기측정결과가 안전기준을 벗어날 시 즉시 밀폐구역을 떠나야 함을 숙지하였습니다.", isChecked: "" },
        ],
        pre3: [
          { isCustom: false, text: "Are those entering person familiar with any breathing apparatus to be used?<br/>작업자는 자장식호흡구의 사용법을 알고 있는가?\n", isChecked: "" },
          { isCustom: false, text: "Has the breathing apparatus been tested as follows?<br/>준비된 자장식호흡구에 대한 다음 사항을 점검하였는가?<br/>" +
              "- Gauge and capacity of air supply<br/>" +
              "- Low pressure audible alarm<br/>" +
              "- Face mask - under positive pressure and not leaking", isChecked: "" },
          { isCustom: false, text: "Has the means of communication has been tested and emergency signals agreed?<br/>통신수단은 시험하였으며 비상신호는 동의하였는가?\n", isChecked: "" },
          { isCustom: false, text: "Have all personnel entering the space been provided with rescue harnesses and, where practicable, lifelines?<br/>작업자에게 rescue harnesses (가능한 경우)와 lifeline이 제공되었는가?", isChecked: "" },
        ],

        pre5: [],
        pre6: [],
        pre7: [
          { text: "Job completed", date: "", time: "", },
          { text: "Space secured against entry", date: "", time: "", },
          { text: "The officer of the watch has been duly informed", date: "", time: "", },
        ],

        fileList: [],

        sign1: {
          rank: "",
          name: "",
          sign: "",
        },
        sign2: {
          rank: "",
          name: "",
          sign: "",
        },
        sign3: {
          rank: "",
          name: "",
          sign: "",
        },

        sign4: {
          name: "",
          sign: "",
          date: "",
        },
        sign5: {
          name: "",
          sign: "",
          date: "",
        },
        sign6: {
          name: "",
          sign: "",
          date: "",
        },
        sign7: {
          name: "",
          sign: "",
          date: "",
        },

        sign8: {
          rank: "",
          name: "",
          sign: "",
        },
        sign9: {
          rank: "",
          name: "",
          sign: "",
        },
        sign10: {
          rank: "",
          name: "",
          sign: "",
        },

        sign11: {
          name: "",
          sign: "",
          date: "",
        },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.sign4': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.sign) {
          this.form.sign4.date = this.saveTime()
        } else {
          this.form.sign4.date = ""
        }
      },
    },
    'form.sign5': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.sign) {
          this.form.sign5.date = this.saveTime()
        } else {
          this.form.sign5.date = ""
        }
      },
    },
    'form.sign6': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.sign) {
          this.form.sign6.date = this.saveTime()
        } else {
          this.form.sign6.date = ""
        }
      },
    },
    'form.sign7': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.sign) {
          this.form.sign7.date = this.saveTime()
        } else {
          this.form.sign7.date = ""
        }
      },
    },
    'form.sign11': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.sign) {
          this.form.sign11.date = this.saveTime()
        } else {
          this.form.sign11.date = ""
        }
      },
    },
  },
  computed: {
    fieldTypesLabel() {
      return {
        writer_name: "Writer",
        date: "Date",
      };
    }
  },
  methods: {
    saveTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = ("0" + (date.getMonth() + 1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);
      let hours = ("0" + date.getHours()).slice(-2);
      let minutes = ("0" + date.getMinutes()).slice(-2);
      let seconds = ("0" + date.getSeconds()).slice(-2);

      let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      return formattedDate;
    },
    handleAddRow1() {
      const data = {
        id: Date.now(),
        time: "",
        o2: "",
        h2s: "",
        ch4: "",
        co: "",
        h4: "",
      }

      this.form.pre5.push(data)
    },
    handleRemoveRow1() {
      this.form.pre5.pop()
    },
    handleAddRow2() {
      const data = {
        id: Date.now(),
        time: "",
        input1: "",
        input2: "",
        input3: "",
        input4: "",
        input5: "",
      }

      this.form.pre6.push(data)
    },
    handleRemoveRow2() {
      this.form.pre6.pop()
    }
  },
};
</script>
<style scoped lang="scss">
.container-title {
  line-height: normal;
  word-break: break-word;
}
.container-subtitle {
  font-weight: 400;
  font-size: 14px;
}
.i-check::v-deep .vs-checkbox {
  margin: 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  thead {
    th {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #3c3c3c;
      background: #f9f9f9;
      padding: 16px 0;
    }
  }

  tbody {
    .title-tr td {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
      padding: 14px;
    }
    .footer-tr td {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
    }
    .sub-title {
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
      padding: 14px 0;
    }

    .content {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      padding: 14px;

      & > div {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 8px;
      }

      &.empty-style {
        padding: 4px !important;
        & > div {
          display: block;
        }
      }

      &::v-deep {
        .vs-radio--label {
          line-height: 0;
        }
      }

      .content-title::before {
        content: '· ';
        margin-bottom: auto;
      }
    }
  }
}
</style>

